import { render, staticRenderFns } from "./HouseOrgan.vue?vue&type=template&id=386b14fe&scoped=true"
import script from "./HouseOrgan.vue?vue&type=script&lang=js"
export * from "./HouseOrgan.vue?vue&type=script&lang=js"
import style0 from "./HouseOrgan.vue?vue&type=style&index=0&id=386b14fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b14fe",
  null
  
)

export default component.exports